import { Fragment, useEffect, useState, useRef } from 'react'
import PageLayout from '../Layouts/PageLayout'
import Spinner from '../FieldComponets/Spinner';
import { useDispatch, useSelector } from 'react-redux';
import { PAGES } from '../../Constants/CommonConstants';
import { MaterialReactTable } from 'material-react-table'
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import React from 'react';
import { getDate, getDateFormatData } from '../../utils/Helper';
import { Link, useNavigate } from 'react-router-dom';
import { setItemToStorage } from '../../utils/Helper';
import ToastDefault from '../FieldComponets/Toast';
import { DashboardRedirectionAction } from '../../Redux/Action/CommonAction';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { userPicUrl } from '../../utils/Helper';
import { NotificationlistGetAction } from '../../Redux/Action/NotificationsAction';

function Notifications() {

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const notificationList = useSelector((state: any) => state.NotificationState);
  const [data, setData] = useState<any>([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [openSerach, setOpenSerach] = useState(false)
  const [sorting, setSorting] = useState<any>(['ASC']);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize
  });
  const [searchValue, setSearchValue] = useState<any>('');
  const [rowCount, setRowCount] = useState(0);

  const columns: any = [
    {
      accessorKey: 'S.NO',
      header: 'S.NO',
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50,
    },
    {
      accessorKey: 'notification_params.title',
      header: 'Title',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'receiver',
      header: 'Receiver',
      accessorFn: (row: { receiver: any; }) => {
        return row?.receiver == '1' 
        ? "All" 
        : row?.receiver == '2' 
        ? "Customer" 
        : row?.receiver == '3' 
        ? "Salon" 
        : row?.receiver == '4' || row?.receiver === 4
        ? "Admin"
        : "Other";      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'notification_params.body',
      header: 'Description',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false
    },
    {
      accessorKey: 'created_at1',
      header: 'Created Date',
      accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: 'date',
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters
        );
        dispatch(DashboardRedirectionAction('RESET'));
        await dispatch(NotificationlistGetAction(query));
      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    // searchValue,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    openSerach
  ]);
  useEffect(() => {
    setData(notificationList?.data?.data?.rows);
    setRowCount(notificationList?.data?.data?.count);
  }, [notificationList?.data]);

  const resetSearchfilter = () => {
    setSearchValue('')
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "search", value: "" },
      { id: "receiver", value: "" },
    ]
    setColumnFilters(columnFilters)

  }
  const handleserach = (e: any) => {
    e.preventDefault()
    const columnFilters = [
      { id: "receiver", value: searchValue?.user_type}
    ]
    setColumnFilters(columnFilters)
  }

  const handleInput =(e:any)=>{
    const {name , value} = e.target
    setSearchValue((serach:any)=>({...serach, [name]:value}))
  }

  return (
    <Fragment>
      {(loading || notificationList?.loading) ? <Spinner /> : ""}


      <PageLayout
        title="Notifications Management"
        breadcrumbs={{
          secLast: { 'link': '/notifications', 'name': 'Notifications Management' },
        }}
        buttons={[
          { url: '/notification-add', className: 'btn btn-primary', text: '+ Add Notification', show: true }, // This button will be shown
        ]}
      >
         <form ref={formRef} onSubmit={handleserach}>
          <div className="row gy-3 align-items-end mb-4">
            <div className='col-sm-6 col-md-4 col-xl-3'>
              <label>Search</label>
              <div className="input-group w-100">
                <div className="input-group">
                  <span className="input-group-text fa-solid fa-magnifying-glass " id="basic-addon1"> <i className="fas fa-search"></i></span>
                  <input type='text' id="saerchId" name='search' className="form-control m-0" placeholder='Search by title' onChange={handleInput} />
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 col-xl-3">
              <label>All Users</label>
              <select className='form-select shadow-none' name="user_type" id="cars" onChange={handleInput}  >
                <option value="">Select type</option>
                <option value="1">All User</option>
                <option value="2">All Customer</option>
                <option value="3">All Salon</option>
              </select>
            </div>
            <div className="col-md-4 col-xl-3">
              <button className='btn theme-bg text-white me-2'>Filter</button>
              <button className='btn btn-success' onClick={() => resetSearchfilter()} >Reset</button>
            </div>
            
          </div>
            
        </form>
     
        {
          data &&
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={true}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: 'Error loading data', } : undefined}
            muiSearchTextFieldProps={{
              placeholder: 'Search from name',
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }
        <ToastDefault />
      </PageLayout>
    </Fragment>
  )
}

export default Notifications